import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { iniCreateBudget } from '../../redux/actions/pptosGastos'

export const Crear = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const crear = () => {
        dispatch(iniCreateBudget())
        navigate(`/gastos/pptos/0`)
    }

    return (
        <button className='btn p-btn-primary' onClick={crear}>
            <i className="bi bi-plus"></i> Crear
        </button>
    )
}
